import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deliveryPiece: {
    id: 'pd.conditionalFreeDelivery.deliveryPieces',
    defaultMessage: 'Doprava zdarma od {value} ks',
  },
  deliveryPrice: {
    id: 'pd.conditionalFreeDelivery.deliveryPrice',
    defaultMessage: 'Doprava zdarma od {price}',
  },
  brands0Categories0: {
    id: 'pd.conditionalFreeDelivery.brands.0.categories.0',
    defaultMessage: 'Platí na vybrané produkty',
  },
  brands1Categories0: {
    id: 'pd.conditionalFreeDelivery.brands.1.categories.0',
    defaultMessage: 'Platí na značku {brand1}',
  },
  brands2Categories0: {
    id: 'pd.conditionalFreeDelivery.brands.2.categories.0',
    defaultMessage: 'Platí na značky {brand1} a {brand2}',
  },
  brands3Categories0: {
    id: 'pd.conditionalFreeDelivery.brands.3.categories.0',
    defaultMessage: 'Platí na značky {brand1}, {brand2} a {brand3}',
  },
  brandsNCategories0: {
    id: 'pd.conditionalFreeDelivery.brands.N.categories.0',
    defaultMessage:
      'Platí na značky {brand1}, {brand2} a <others>další</others>',
  },
  brands0Categories1: {
    id: 'pd.conditionalFreeDelivery.brands.0.categories.1',
    defaultMessage: 'Platí na kategorii {category1}',
  },
  brands0Categories2: {
    id: 'pd.conditionalFreeDelivery.brands.0.categories.2',
    defaultMessage: 'Platí na kategorie {category1} a {category2}',
  },
  brands0Categories3: {
    id: 'pd.conditionalFreeDelivery.brands.0.categories.3',
    defaultMessage: 'Platí na kategorie {category1}, {category2} a {category3}',
  },
  brands0CategoriesN: {
    id: 'pd.conditionalFreeDelivery.brands.0.categories.N',
    defaultMessage:
      'Platí na kategorie {category1}, {category2} a <others>další</others>',
  },
  brands1Categories1: {
    id: 'pd.conditionalFreeDelivery.brands.1.categories.1',
    defaultMessage: 'Platí na značku {brand1} a kategorii {category1}',
  },
  brands1Categories2: {
    id: 'pd.conditionalFreeDelivery.brands.1.categories.2',
    defaultMessage:
      'Platí na značku {brand1} a kategorie {category1}, {category2}',
  },
  brands2Categories1: {
    id: 'pd.conditionalFreeDelivery.brands.2.categories.1',
    defaultMessage:
      'Platí na značky {brand1}, {brand2} a kategorii {category1}',
  },
  brands2Categories2: {
    id: 'pd.conditionalFreeDelivery.brands.2.categories.2',
    defaultMessage:
      'Platí na značky {brand1}, {brand2} a kategorie {category1}, {category2}',
  },
  brandsNCategoriesN: {
    id: 'pd.conditionalFreeDelivery.brands.N.categories.N',
    defaultMessage: 'Platí na <these>tyto</these> značky a kategorie',
  },
  selectedProducts: {
    id: 'pd.conditionalFreeDelivery.selectedProducts',
    defaultMessage: 'Platí na vybrané produkty',
  },
  tooltipInfo: {
    id: 'pd.conditionalFreeDelivery.tooltipInfo',
    defaultMessage:
      'Doprava zdarma se při splnění podmínek aplikuje v košíku automaticky.',
  },
});
